import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import type { BusinessRole } from "@adva/types";

interface InviteBusinessMemberData {
  email: string;
  role: BusinessRole;
}

interface InviteBusinessMemberResponse {
  action: "invited_new" | "added_existing" | "already_member";
  message: string;
}

export function useInviteBusinessMember() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: InviteBusinessMemberData) =>
      api.post<InviteBusinessMemberResponse>("/core/me/business/members", data),
    onSuccess: (data) => {
      if (data.action !== "already_member") {
        queryClient.invalidateQueries({ queryKey: ["business-members"] });
      }
    },
  });
}
